import { Button } from 'antd'
import styled, { css } from 'styled-components'

const StyledMenuTitleIgnoreButton = styled(Button)`
  margin-right: 15px;
  ${props =>
    props.isUsed &&
    css`
      background-color: #a3a3a3;
    `};
`

export default StyledMenuTitleIgnoreButton
